export default __webpack_public_path__ + "static/media/0af7c12134398c05d4f6019513876d3a1602462511112.1fbefda2.webp";